const ButtonDownload = ({ title = 'Завантажити', disabled = false, handler = null }) => {
  return (
    <button
      onClick={handler}
      disabled={disabled}
      className="btn btn_white btn_download"
      type="button"
    >
      {title}
    </button>
  )
}

export default ButtonDownload
